import { render, staticRenderFns } from "./dissAssociation.vue?vue&type=template&id=192a6b01&"
import script from "./dissAssociation.vue?vue&type=script&lang=js&"
export * from "./dissAssociation.vue?vue&type=script&lang=js&"
import style0 from "./dissAssociation.vue?vue&type=style&index=0&id=192a6b01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports